export default "__VITE_ASSET__tHf8LDLU__"